var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8734 18.2681C27.8512 18.3015 27.8316 18.3361 27.8094 18.3695L27.6398 18.2681H26.9624C26.8619 18.4041 26.7588 18.539 26.6504 18.6676L27.2482 19.1203C27.0472 19.3591 26.8292 19.5904 26.6008 19.8069L26.0605 19.2947C25.8517 19.4927 25.6311 19.6794 25.4001 19.8551L25.8778 20.4216C25.6259 20.6121 25.3596 20.7915 25.0868 20.9548L24.6796 20.3412C24.4303 20.4897 24.1719 20.6257 23.9057 20.7482L24.2385 21.4001C23.9474 21.5337 23.6459 21.6524 23.3405 21.7538L23.0873 21.0698C22.8106 21.1613 22.5261 21.2393 22.2363 21.3023L22.406 22.0087C22.0915 22.0767 21.7691 22.1286 21.448 22.162L21.3632 21.4421C21.0773 21.4731 20.7863 21.4891 20.4926 21.4891L20.4783 21.7402V22.214H20.4743C20.152 22.214 19.8283 22.1967 19.5098 22.1633L19.5947 21.4421C19.2984 21.4112 19.0073 21.3642 18.7215 21.3036L18.5518 22.0099C18.236 21.9419 17.9214 21.8565 17.6173 21.7551L17.8692 21.071C17.5886 20.9783 17.3158 20.8719 17.0496 20.7507L16.7181 21.4038C16.427 21.2714 16.1412 21.1205 15.8671 20.9585L16.2743 20.3449C16.0237 20.1953 15.7822 20.0332 15.5512 19.8588L15.0748 20.4253C14.8229 20.2348 14.5789 20.0283 14.3505 19.8118L14.8908 19.2997C14.682 19.1018 14.4849 18.8927 14.2996 18.6738L13.7018 19.1265C13.4995 18.8878 13.3103 18.6354 13.138 18.3769L13.3181 18.2693H7.52441V20.4538C7.52441 20.8434 7.74368 21.2046 8.1 21.4001L19.8935 27.8533C20.2499 28.0488 20.6897 28.0488 21.046 27.8533L32.8396 21.4001C33.1959 21.2046 33.4151 20.8447 33.4151 20.4538V18.2693H27.8734V18.2681ZM21.4415 24.3045L20.9325 24.6545C20.9116 24.6694 20.9024 24.6941 20.9116 24.7176L21.1061 25.2854C21.1243 25.3373 21.0617 25.3794 21.0147 25.3485L20.5057 24.9984C20.4848 24.9836 20.4574 24.9836 20.4365 24.9984L19.9275 25.3485C19.8818 25.3806 19.8192 25.3373 19.8361 25.2854L20.0306 24.7176C20.0384 24.6941 20.0293 24.6694 20.0097 24.6545L19.5007 24.3045C19.4537 24.2723 19.4785 24.203 19.5359 24.203H20.165C20.1911 24.203 20.2133 24.187 20.2211 24.1647L20.4156 23.5969C20.4339 23.545 20.5109 23.545 20.5279 23.5969L20.7223 24.1647C20.7302 24.1882 20.7524 24.203 20.7785 24.203H21.4075C21.4637 24.203 21.4872 24.2723 21.4415 24.3045Z",
    fill: "url(#paint0_linear_2057_490)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6861 8.88452C13.8871 8.64579 14.105 8.41447 14.3334 8.19677L14.8751 8.70887C15.0839 8.51096 15.3045 8.32417 15.5355 8.14852L15.0578 7.58199C15.3097 7.39026 15.5759 7.2109 15.8487 7.04762L16.2572 7.66116C16.5065 7.51272 16.765 7.37542 17.0312 7.25296L16.6984 6.60108C16.9895 6.46748 17.2909 6.34874 17.5964 6.24731L17.8509 6.93135C18.1276 6.83858 18.4121 6.76065 18.7018 6.69756L18.5309 5.99125C18.8454 5.92322 19.1678 5.87127 19.4889 5.83663L19.575 6.55655C19.8647 6.52562 20.1597 6.50831 20.4599 6.50831V5.78344H20.473C20.7927 5.78344 21.1138 5.79952 21.4297 5.83292L21.3461 6.55407C21.6424 6.585 21.9348 6.63076 22.2206 6.69261L22.389 5.98507C22.7048 6.0531 23.0194 6.13721 23.3248 6.23865L23.0729 6.92393C23.3535 7.0167 23.6276 7.12308 23.8925 7.2443L24.224 6.59118C24.5151 6.72354 24.8009 6.87321 25.075 7.03649L24.6691 7.65126C24.9197 7.80094 25.1611 7.96298 25.3922 8.13616L25.8685 7.56839C26.1218 7.75888 26.3658 7.96545 26.5942 8.18069L26.0539 8.69403C26.2601 8.88823 26.4533 9.09357 26.636 9.3088H26.6595L27.2429 8.86597C27.3643 9.00945 27.4778 9.15789 27.5901 9.3088H33.4216V7.54612C33.4216 7.15648 33.2023 6.79528 32.846 6.59984L21.0459 0.146581C20.6896 -0.0488602 20.2498 -0.0488602 19.8935 0.146581L8.10122 6.59984C7.7449 6.79528 7.52563 7.15524 7.52563 7.54612V9.3088H14.2499L13.6861 8.88452ZM19.5332 3.28353H20.1623C20.1884 3.28353 20.2106 3.26745 20.2185 3.24518L20.4129 2.67742C20.4312 2.62546 20.5082 2.62546 20.5252 2.67742L20.7196 3.24518C20.7275 3.26869 20.7497 3.28353 20.7758 3.28353H21.4049C21.4623 3.28353 21.4858 3.3528 21.4401 3.38496L20.9311 3.73502C20.9102 3.74987 20.9011 3.77461 20.9102 3.79811L21.1047 4.36588C21.1229 4.41783 21.0603 4.45989 21.0133 4.42896L20.5043 4.0789C20.4834 4.06406 20.456 4.06406 20.4351 4.0789L19.9261 4.42896C19.8804 4.46112 19.8178 4.41783 19.8347 4.36588L20.0292 3.79811C20.037 3.77461 20.0279 3.74987 20.0083 3.73502L19.4993 3.38496C19.4523 3.3528 19.4758 3.28353 19.5332 3.28353Z",
    fill: "url(#paint1_linear_2057_490)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3316 13.5046C34.0248 13.5046 33.7769 13.7397 33.7769 14.0303C33.7769 14.321 34.0248 14.5561 34.3316 14.5561C34.6383 14.5561 34.8863 14.321 34.8863 14.0303C34.8863 13.7397 34.6383 13.5046 34.3316 13.5046Z",
    fill: "url(#paint2_linear_2057_490)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9644 13.8719C40.3053 11.9608 39.6461 10.0484 38.987 8.13732C38.8696 7.79716 38.4963 7.59924 38.1295 7.68459C33.5379 8.74715 27.4454 9.71198 20.2578 9.66869C13.2516 9.62663 7.38746 8.77807 2.88461 7.71304C2.51786 7.62646 2.14458 7.8219 2.0245 8.16206C1.37844 9.99896 0.676258 11.7431 0.0354175 13.5961C-0.0128739 13.7371 -0.0115687 13.8892 0.0380279 14.0302C0.736296 15.9785 1.43587 17.9279 2.13414 19.8761C2.25682 20.2176 2.63532 20.4105 3.00338 20.319C7.49449 19.1933 13.6014 18.1246 20.8725 18.1531C27.9714 18.1815 33.9438 19.249 38.3684 20.3722C38.7482 20.4687 39.1397 20.2596 39.2494 19.9009C39.8236 18.0256 40.3966 16.1504 40.9709 14.2752C41.0114 14.1428 41.01 14.003 40.9644 13.8719ZM2.92638 18.2904C2.90811 18.2953 2.89114 18.2978 2.87287 18.2978C2.79847 18.2978 2.7293 18.2532 2.7058 18.1827C2.69667 18.1555 1.78566 15.4589 1.27142 14.0129C1.21138 13.8447 1.20616 13.6653 1.25576 13.4946C1.63687 12.1723 2.63532 9.88763 2.64446 9.86537C2.68101 9.78125 2.78411 9.74043 2.87287 9.77507C2.96162 9.80971 3.00469 9.90743 2.96814 9.99154C2.9577 10.0138 1.96838 12.2799 1.5938 13.5812C1.56247 13.6876 1.56639 13.8002 1.60424 13.9065C2.11978 15.355 3.0321 18.0541 3.04123 18.0813C3.06995 18.1691 3.01905 18.2619 2.92638 18.2904ZM3.79693 18.2904C3.77866 18.2953 3.76169 18.2978 3.74342 18.2978C3.66902 18.2978 3.59985 18.2532 3.57635 18.1827C3.56722 18.1555 2.65621 15.4589 2.14197 14.0129C2.08193 13.8447 2.07671 13.6653 2.12631 13.4946C2.50742 12.1723 3.50587 9.88763 3.51501 9.86537C3.55156 9.78125 3.65466 9.74043 3.74342 9.77507C3.83217 9.80971 3.87524 9.90743 3.83869 9.99154C3.82825 10.0138 2.83893 12.2799 2.46435 13.5812C2.43302 13.6876 2.43694 13.8002 2.47479 13.9065C2.99033 15.355 3.90265 18.0541 3.91178 18.0813C3.93919 18.1691 3.88829 18.2619 3.79693 18.2904ZM4.66617 18.2904C4.6479 18.2953 4.63093 18.2978 4.61266 18.2978C4.53827 18.2978 4.46909 18.2532 4.4456 18.1827C4.43646 18.1555 3.52545 15.4589 3.01121 14.0129C2.95118 13.8447 2.94596 13.6653 2.99555 13.4946C3.37666 12.1723 4.37512 9.88763 4.38426 9.86537C4.4208 9.78125 4.52391 9.74043 4.61266 9.77507C4.70141 9.80971 4.74448 9.90743 4.70794 9.99154C4.6975 10.0138 3.70818 12.2799 3.33359 13.5812C3.30227 13.6876 3.30618 13.8002 3.34403 13.9065C3.85958 15.355 4.77189 18.0541 4.78103 18.0813C4.80844 18.1691 4.75754 18.2619 4.66617 18.2904ZM7.57671 14.483C7.57671 14.5102 7.56105 14.5362 7.53625 14.5498L6.70877 15.0025C6.68397 15.0161 6.65265 15.0161 6.62785 15.0025L5.80037 14.5498C5.77557 14.5362 5.75991 14.5114 5.75991 14.483V13.5775C5.75991 13.5503 5.77557 13.5243 5.80037 13.5107L6.62785 13.058C6.65265 13.0444 6.68397 13.0444 6.70877 13.058L7.53625 13.5107C7.56105 13.5243 7.57671 13.5503 7.57671 13.5775V14.483ZM14.515 17.0447L14.0504 15.4614H11.8681L11.4035 17.0447H9.96127L11.8068 11.3893C11.8368 11.2854 11.8968 11.2013 11.9856 11.137C12.0743 11.0726 12.1761 11.0417 12.2936 11.0417H13.6249C13.741 11.0417 13.8442 11.0739 13.9329 11.137C14.0217 11.2013 14.0817 11.2854 14.1117 11.3893L15.9481 17.0447H14.515ZM18.1225 12.1859C18.0364 12.2638 17.9946 12.3814 17.9946 12.5385V17.0447H16.5889V12.2688C16.5889 11.8977 16.7129 11.5959 16.9609 11.3646C17.2089 11.1333 17.5261 11.017 17.9111 11.017C18.394 11.017 18.886 11.0207 19.3846 11.0294C19.8832 11.038 20.3439 11.0652 20.7668 11.1122L20.7028 12.0696H18.4997C18.334 12.0684 18.2087 12.108 18.1225 12.1859ZM24.7502 17.0447L24.2855 15.4614H22.1033L21.6387 17.0447H20.1977L22.0433 11.3893C22.0733 11.2854 22.1333 11.2013 22.2221 11.137C22.3108 11.0726 22.4126 11.0417 22.5301 11.0417H23.8614C23.9775 11.0417 24.0806 11.0739 24.1694 11.137C24.2581 11.2013 24.3182 11.2854 24.3482 11.3893L26.1846 17.0447H24.7502ZM31.0385 12.0857H29.129V17.0447H27.7247V12.0857H25.8243V11.0417H27.7247H29.129H31.0385V12.0857ZM35.2399 14.483C35.2399 14.5102 35.2242 14.5362 35.1994 14.5498L34.3719 15.0025C34.3471 15.0161 34.3158 15.0161 34.291 15.0025L33.4635 14.5498C33.4387 14.5362 33.4231 14.5114 33.4231 14.483V13.5775C33.4231 13.5503 33.4387 13.5243 33.4635 13.5107L34.291 13.058C34.3158 13.0444 34.3471 13.0444 34.3719 13.058L35.1994 13.5107C35.2242 13.5243 35.2399 13.5503 35.2399 13.5775V14.483ZM36.3884 18.2978C36.3702 18.2978 36.3532 18.2953 36.3349 18.2904C36.2423 18.2619 36.1926 18.1691 36.2214 18.0813C36.2305 18.0541 37.1428 15.355 37.6584 13.9065C37.6962 13.8014 37.7001 13.6888 37.6688 13.5812C37.2929 12.2799 36.3036 10.0138 36.2945 9.99154C36.2579 9.90743 36.2997 9.80971 36.3897 9.77507C36.4785 9.74043 36.5816 9.78002 36.6181 9.86537C36.6286 9.88887 37.6257 12.1723 38.0068 13.4946C38.0564 13.6653 38.0499 13.8447 37.9912 14.0129C37.4769 15.4589 36.5659 18.1555 36.5568 18.1827C36.5307 18.2532 36.4615 18.2978 36.3884 18.2978ZM37.2577 18.2978C37.2394 18.2978 37.2224 18.2953 37.2042 18.2904C37.1115 18.2619 37.0619 18.1691 37.0906 18.0813C37.0997 18.0541 38.0121 15.355 38.5276 13.9065C38.5655 13.8014 38.5694 13.6888 38.538 13.5812C38.1622 12.2799 37.1728 10.0138 37.1637 9.99154C37.1272 9.90743 37.1689 9.80971 37.259 9.77507C37.3477 9.74043 37.4508 9.78002 37.4874 9.86537C37.4978 9.88887 38.495 12.1723 38.8761 13.4946C38.9257 13.6653 38.9192 13.8447 38.8604 14.0129C38.3462 15.4589 37.4352 18.1555 37.426 18.1827C37.3999 18.2532 37.3308 18.2978 37.2577 18.2978ZM39.7284 14.0129C39.2141 15.4589 38.3031 18.1555 38.294 18.1827C38.2705 18.2532 38.2013 18.2978 38.1269 18.2978C38.1086 18.2978 38.0917 18.2953 38.0734 18.2904C37.9807 18.2619 37.9311 18.1691 37.9599 18.0813C37.969 18.0541 38.8813 15.355 39.3969 13.9065C39.4347 13.8014 39.4386 13.6888 39.4073 13.5812C39.0314 12.2799 38.0421 10.0138 38.0329 9.99154C37.9964 9.90743 38.0382 9.80971 38.1282 9.77507C38.217 9.74043 38.3201 9.78002 38.3566 9.86537C38.3671 9.88887 39.3642 12.1723 39.7453 13.4946C39.7936 13.6653 39.7884 13.8435 39.7284 14.0129Z",
    fill: "url(#paint3_linear_2057_490)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3825 12.3344C23.3577 12.233 23.3368 12.1353 23.3185 12.0425H23.0705C23.0523 12.1353 23.0327 12.233 23.0105 12.3344C22.9883 12.4358 22.9635 12.536 22.9322 12.635L22.3958 14.462H23.9907L23.4542 12.635C23.4321 12.5348 23.4073 12.4358 23.3825 12.3344Z",
    fill: "url(#paint4_linear_2057_490)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1471 12.3344C13.1223 12.233 13.1014 12.1353 13.0832 12.0425H12.8352C12.8169 12.1353 12.7973 12.233 12.7751 12.3344C12.7529 12.4358 12.7282 12.536 12.6968 12.635L12.1604 14.462H13.7553L13.2189 12.635C13.1954 12.5348 13.1719 12.4358 13.1471 12.3344Z",
    fill: "url(#paint5_linear_2057_490)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66822 13.5046C6.36151 13.5046 6.11353 13.7397 6.11353 14.0303C6.11353 14.321 6.36151 14.5561 6.66822 14.5561C6.97494 14.5561 7.22292 14.321 7.22292 14.0303C7.22292 13.7397 6.97494 13.5046 6.66822 13.5046Z",
    fill: "url(#paint6_linear_2057_490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2057_490",
    x1: 4.45587,
    y1: 26.536,
    x2: 48.6534,
    y2: 9.17055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85868C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3427,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#5C5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2057_490",
    x1: -0.368997,
    y1: 14.2563,
    x2: 43.8286,
    y2: -3.10912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85868C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3427,
    stopColor: "#C1C1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#5C5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2057_490",
    x1: 3.77893,
    y1: 24.8128,
    x2: 47.9765,
    y2: 7.44734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1451,
    stopColor: "#39393F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#414147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#4F4F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    stopColor: "#646468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#7E7E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4794,
    stopColor: "#9E9E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ACACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5494,
    stopColor: "#858587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    stopColor: "#656569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#4A4A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#36363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    stopColor: "#28282E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#202026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2057_490",
    x1: 2.11553,
    y1: 20.5793,
    x2: 46.3131,
    y2: 3.21382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1451,
    stopColor: "#39393F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#414147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#4F4F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    stopColor: "#646468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#7E7E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4794,
    stopColor: "#9E9E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ACACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5494,
    stopColor: "#858587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    stopColor: "#656569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#4A4A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#36363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    stopColor: "#28282E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#202026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2057_490",
    x1: 2.19505,
    y1: 20.7815,
    x2: 46.3926,
    y2: 3.41604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1451,
    stopColor: "#39393F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#414147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#4F4F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    stopColor: "#646468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#7E7E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4794,
    stopColor: "#9E9E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ACACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5494,
    stopColor: "#858587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    stopColor: "#656569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#4A4A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#36363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    stopColor: "#28282E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#202026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2057_490",
    x1: 0.948439,
    y1: 17.6091,
    x2: 45.146,
    y2: 0.243674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1451,
    stopColor: "#39393F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#414147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#4F4F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    stopColor: "#646468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#7E7E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4794,
    stopColor: "#9E9E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ACACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5494,
    stopColor: "#858587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    stopColor: "#656569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#4A4A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#36363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    stopColor: "#28282E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#202026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2057_490",
    x1: 0.410124,
    y1: 16.2391,
    x2: 44.6077,
    y2: -1.12632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1451,
    stopColor: "#39393F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2323,
    stopColor: "#414147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#4F4F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3679,
    stopColor: "#646468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#7E7E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4794,
    stopColor: "#9E9E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ACACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5022,
    stopColor: "#AAAAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5494,
    stopColor: "#858587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5995,
    stopColor: "#656569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#4A4A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#36363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    stopColor: "#28282E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8636,
    stopColor: "#202026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.84f23f357c39913d4aec598b797e4958.svg";
export { ForwardRef as ReactComponent };